import { useCallback, useRef } from 'react'
import HttpClient from '../helpers/http-client'
import { prepareRequestUrl } from '../helpers/utils'

type TUseScannerProps = {
  baseUrl: string
  endpoints?: {
    startInference?: string
    stopInference?: string
    startVideoFeed?: string
    stopVideoFeed?: string
    captureFrame?: string
  }
}

const useScanner = ({ baseUrl, endpoints = {} }: TUseScannerProps) => {
  const httpClient = useRef(new HttpClient({ baseUrl }))
  const getVideoStreamUrl = useCallback(() => {
    return (
      endpoints.startVideoFeed ||
      prepareRequestUrl('/video_feed?client_id=computer-vision', baseUrl)
    )
  }, [endpoints.startVideoFeed, baseUrl])

  const startInference = () => {
    // start inference
    return httpClient.current.get(
      endpoints.startInference || '/start-inference',
    )
  }

  const stopInference = () => {
    // stop inference
    return httpClient.current.get(endpoints.stopInference || '/stop-inference')
  }

  const captureFrame = async () => {
    await stopInference()
    return httpClient.current.get(endpoints.captureFrame || '/frame/capture')
  }

  return { getVideoStreamUrl, startInference, stopInference, captureFrame }
}

export default useScanner
